import { render, staticRenderFns } from "./concAddress.vue?vue&type=template&id=5b63303b&scoped=true&"
import script from "./concAddress.vue?vue&type=script&lang=js&"
export * from "./concAddress.vue?vue&type=script&lang=js&"
import style0 from "./concAddress.vue?vue&type=style&index=0&id=5b63303b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63303b",
  null
  
)

export default component.exports